// import React, { useEffect, useState, useRef } from "react";
// import { Modal, Button, Table, Pagination, Row, Col } from "react-bootstrap";
// import { BsFiletypeXls } from "react-icons/bs";
// import { FaCalendar, FaTimes } from "react-icons/fa";
// import { MdFilterAltOff, MdFilterAlt } from "react-icons/md";
// import { RiFilterFill } from "react-icons/ri";
// import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const API_URL = process.env.REACT_APP_API_URL;

// function AdminWalletLedger() {
//   const [ledger, setLedger] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchTerm, setSearchTerm] = useState({ amount: "", type: "" });
//   const [showFilter, setShowFilter] = useState(false);
//   const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1199);
//   const [totals, setTotals] = useState({ total_credit: 0, total_debit: 0 });
//   const [summary, setSummary] = useState({
//     total_cr: 0,
//     total_dr: 0,
//     opening_balance: 0,
//     closing_balance: 0,
//     current_balance: 0,
//   });
//   const token = localStorage.getItem("token");
//   const [filterFromDate, setFilterFromDate] = useState("");
//   const [filterToDate, setFilterToDate] = useState("");
//   const [filterToType, setFilterToType] = useState("");
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [currentPageRecords, setCurrentPageRecords] = useState(0);

//   const datePickerRef = useRef(null);
//   const handleIconClick = () => {
//     datePickerRef.current.setOpen(true);
//   };
//   const handleClear = () => {
//     setFilterFromDate(null);
//   };

//   const pageLimit = 10;
//   const toggleFilter = () => setShowFilter((prev) => !prev);
//   const showCustomMessageModal = (title, text) => {
//     alert(`${title}: ${text}`);
//   };

//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth >= 1199) {
//         setIsDesktop(true);
//         setShowFilter(true);
//       } else {
//         setIsDesktop(false);
//         setShowFilter(false);
//       }
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const formatDateForServer = (date) => {
//     if (!date) return "";
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${year}-${month}-${day}`;
//   };
//   // const formatDateForServer = (dateStr) => {
//   //   if (!dateStr) return "";
//   //   const parts = dateStr.split("-");
//   //   if (parts.length !== 3) return "";
//   //   const [dd, mm, yyyy] = parts;
//   //   return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
//   // };

//   const fetchLedger = async (page = 1) => {
//     setLoading(true);
//     try {
//       console.log("Fetching page:", page);
//       const params = new URLSearchParams();

//       // Add filters if available
//       if (searchTerm.type || filterToType) {
//         params.append("type", searchTerm.type || filterToType);
//       }
//       if (filterFromDate) {
//         params.append("start_date", formatDateForServer(filterFromDate));
//       }
//       if (filterToDate) {
//         params.append("end_date", formatDateForServer(filterToDate));
//       }

//       // Server-side pagination parameters
//       params.append("page", page);
//       params.append("limit", pageLimit);

//       const url = `${API_URL}/get-admin-wallet-ledgers-with-summary?${params.toString()}`;
//       console.log("API URL:", url);

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       console.log("Response status:", response.status);

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();
//       console.log("API Response:", result);

//       if (result.success === "1" || result.success) {
//         // Set ledger data
//         setLedger(result.data?.ledger || []);
//         setCurrentPageRecords(result.data?.ledger?.length || 0);

//         // Set summary data
//         if (result.data?.summary) {
//           setSummary(result.data.summary);
//           setTotals({
//             total_credit: result.data.summary.total_cr || 0,
//             total_debit: result.data.summary.total_dr || 0,
//           });
//         }

//         // Set pagination data
//         if (result.data?.pagination) {
//           const paginationData = result.data.pagination;
//           setTotalRecords(paginationData.total_records || 0);

//           // Calculate total pages based on total_records and pageLimit
//           const totalPagesCount = Math.ceil(
//             (paginationData.total_records || 0) / pageLimit,
//           );
//           setTotalPages(totalPagesCount || 1);
//         }

//         // Set current page
//         setCurrentPage(page);
//       } else {
//         showCustomMessageModal(
//           "Error",
//           result.message || "Failed to fetch records.",
//         );
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//       showCustomMessageModal(
//         "Error",
//         "Failed to fetch ledger data. Please check console for details.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLedger();
//   }, []);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     fetchLedger(1);
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//       fetchLedger(pageNumber);
//     }
//   };

//   const getPaginationGroup = () => {
//     // Agar total pages 7 se kam hain, to sab dikha do
//     if (totalPages <= 7) {
//       return Array.from({ length: totalPages }, (_, i) => i + 1);
//     }

//     // Agar current page start ke 3 pages mein hai
//     if (currentPage <= 3) {
//       return [1, 2, 3, 4, "...", totalPages];
//     }

//     // Agar current page last ke 3 pages mein hai
//     if (currentPage >= totalPages - 2) {
//       return [
//         1,
//         "...",
//         totalPages - 3,
//         totalPages - 2,
//         totalPages - 1,
//         totalPages,
//       ];
//     }

//     // Middle pages ke liye
//     return [
//       1,
//       "...",
//       currentPage - 1,
//       currentPage,
//       currentPage + 1,
//       "...",
//       totalPages,
//     ];
//   };

//   // Helper functions
//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return "-";
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       return "-";
//     }
//   };

//   const formatAmount = (amount) => {
//     if (amount === undefined || amount === null) return "0.00";
//     const num = parseFloat(amount);
//     if (isNaN(num)) return "0.00";
//     return num.toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//   };

//   // Get payee/transaction name
//   const getTransactionName = (item) => {
//     if (item.transaction_name) return item.transaction_name;
//     if (item.payee) return item.payee;
//     if (item.associate?.name) return item.associate.name;
//     return "-";
//   };

//   // Get project/plot info
//   const getProjectPlotInfo = (item) => {
//     const projectName = item.project?.name || "";
//     const plotName = item.plot?.name || "";

//     if (projectName && plotName) {
//       return `${projectName} - ${plotName}`;
//     } else if (projectName) {
//       return projectName;
//     } else if (plotName) {
//       return plotName;
//     }
//     return "-";
//   };

//   // Get category info
//   const getCategoryInfo = (item) => {
//     if (item.category?.name) {
//       return `${item.category.name} (${item.category.type || ""})`;
//     }
//     return "-";
//   };

//   // Get associate info
//   const getAssociateInfo = (item) => {
//     if (item.associate?.name && item.associate?.mobile) {
//       return `${item.associate.name} (${item.associate.mobile})`;
//     }
//     return "-";
//   };

//   const handleDownloadFilteredExcel = async () => {
//     const token = localStorage.getItem("token");

//     try {
//       Swal.fire({
//         title: "Please wait...",
//         text: "Generating your filtered Excel file",
//         allowOutsideClick: false,
//         didOpen: () => Swal.showLoading(),
//       });

//       const params = new URLSearchParams({
//         amount: searchTerm.amount,
//         type: searchTerm.type || filterToType,
//         start_date: formatDateForServer(filterFromDate),
//         end_date: formatDateForServer(filterToDate),
//       }).toString();

//       const response = await fetch(
//         `${API_URL}/download-admin-wallet-ledger-excel?${params.toString()}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (!response.ok) throw new Error("Failed to download Excel");

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Filtered Admin Wallet Ledger Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       Swal.fire({
//         icon: "success",
//         title: "Download Successful!",
//         text: "Filtered Excel report has been downloaded successfully.",
//         showConfirmButton: false,
//         timer: 2000,
//       });
//     } catch (error) {
//       console.error("Filtered Excel download failed:", error);
//       Swal.fire({
//         icon: "warning",
//         title: "Download Failed!",
//         text: "Please Check Entered From Date & To Date For Downloding Admin Wallet Ledger Report.",
//       });
//     }
//   };

//   // Clear filters
//   const handleClearFilters = () => {
//     setFilterFromDate("");
//     setFilterToDate("");
//     setFilterToType("");
//     setSearchTerm({ amount: "", type: "" });
//     setCurrentPage(1);
//     fetchLedger(1);
//   };

//   return (
//     <div className="padding_15">
//       <div className="userlist">
//         <div className="card shadow-sm mb-3">
//           <div className="card-header flex-wrap-mobile d-flex justify-content-between align-items-center gap-2">
//             <div className="titlepage">
//               <h3>Admin Wallet Ledger Report</h3>
//             </div>
//             <div className="d-flex align-items-center gap-2">
//               <Button
//                 className="buttonpadding d-flex gap-2"
//                 variant="primary"
//                 onClick={handleDownloadFilteredExcel}
//               >
//                 <BsFiletypeXls className="text-white fs-6" />
//                 Download
//               </Button>
//               <button
//                 className={`filter-toggle-btn btn btn-primary ${isFilterActive ? "active" : ""}`}
//                 onClick={handleToggle}
//               >
//                 {isFilterActive ? (
//                   <>
//                     <MdFilterAltOff />
//                   </>
//                 ) : (
//                   <>
//                     <MdFilterAlt />
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>

//           {isFilterActive && (
//             <div className="card-body">
//               <div className="d-flex flex-wrap-mobile justify-content-between align-items-center gap-2">
//                 <div className="position-relative w-100">
//                   <div
//                     className="position-absolute"
//                     style={{ top: "8px", right: "20px" }}
//                   >
//                     {!filterFromDate ? (
//                       <FaCalendar onClick={handleIconClick} />
//                     ) : (
//                       <FaTimes onClick={handleClear} />
//                     )}
//                   </div>

//                   <DatePicker
//                     ref={datePickerRef}
//                     selected={filterFromDate}
//                     onChange={(date) => setFilterFromDate(date)}
//                     placeholderText="DD-MM-YYYY"
//                     dateFormat="dd-MM-yyyy"
//                     className="form-control w-100"
//                     // isClearable={true}
//                     showPopperArrow={false}
//                   />
//                 </div>
//                 <div className="position-relative w-100">
//                   <div
//                     className="position-absolute"
//                     style={{ top: "8px", right: "20px" }}
//                   >
//                     {!filterFromDate ? (
//                       <FaCalendar onClick={handleIconClick} />
//                     ) : (
//                       <FaTimes onClick={handleClear} />
//                     )}
//                   </div>

//                   <DatePicker
//                     ref={datePickerRef}
//                     selected={filterToDate}
//                     onChange={(date) => setFilterToDate(date)}
//                     placeholderText="DD-MM-YYYY"
//                     dateFormat="dd-MM-yyyy"
//                     className="form-control"
//                     // isClearable={true}
//                     showPopperArrow={false}
//                   />
//                 </div>
//                 <Button
//                   className="filter-toggle-btn btn"
//                   variant="primary"
//                   onClick={() => fetchLedger(1)}
//                 >
//                   <RiFilterFill /> Filter
//                 </Button>
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="mb-4 card">
//           <div className="card-header">
//             <h5 className="mb-0">Summary</h5>
//           </div>
//           <div className="card-body pb-0">
//             <Row className="gy-2">
//               <Col md={4} className="mb-2">
//                 <div className="card border-success bg_card_design clickable-card">
//                   <div className="card-body p-2 text-center">
//                     <h6 className="card-title text-success">Total Credit</h6>
//                     <p className="fw-semibold mb-0 mt-1">
//                       ₹ {formatAmount(summary.total_cr)}
//                     </p>
//                   </div>
//                 </div>
//               </Col>

//               <Col md={4} className="mb-2">
//                 <div className="card border-danger bg_card_design clickable-card">
//                   <div className="card-body p-2 text-center">
//                     <h6 className="card-title text-danger">Total Debit</h6>
//                     <p className="fw-semibold mb-0 mt-1">
//                       ₹ {formatAmount(summary.total_dr)}
//                     </p>
//                   </div>
//                 </div>
//               </Col>

//               {/* <Col md={2} className="mb-2">
//                 <div className="card border-primary bg_card_design clickable-card" style={{ height: "90px" }}>
//                   <div className="card-body p-2 text-center">
//                     <h6 className="card-title text-primary">Opening</h6>
//                     <p className="fw-semibold mb-0 mt-1" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>
//                       ₹ {formatAmount(summary.opening_balance)}
//                     </p>
//                   </div>
//                 </div>
//               </Col>

//               <Col md={2} className="mb-2">
//                 <div className="card border-info bg_card_design clickable-card" style={{ height: "90px" }}>
//                   <div className="card-body p-2 text-center">
//                     <h6 className="card-title text-info">Closing</h6>
//                     <p className="fw-semibold mb-0 mt-1" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>
//                       ₹ {formatAmount(summary.closing_balance)}
//                     </p>
//                   </div>
//                 </div>
//               </Col> */}

//               <Col md={4} className="mb-2">
//                 <div className="card border-warning bg_card_design clickable-card">
//                   <div className="card-body p-2 text-center">
//                     <h6 className="card-title text-warning">Current</h6>
//                     <p className="fw-semibold mb-0 mt-1">
//                       ₹ {formatAmount(summary.current_balance)}
//                     </p>
//                   </div>
//                 </div>
//               </Col>
//             </Row>
//           </div>

//           <div className="card-body">
//             {/* Total Records Info */}
//             {/* <div className="mb-3 p-2 bg-info text-white rounded">
//               <div className="d-flex justify-content-between align-items-center">
//                 <span className="fw-bold">Total Records: {totalRecords}</span>
//                 <span className="fw-bold">Page: {currentPage} of {totalPages}</span>
//               </div>
//             </div> */}

//             {/* Table */}
//             {loading ? (
//               <div className="text-center p-5">
//                 <div className="spinner-border text-primary" role="status">
//                   <span className="visually-hidden">Loading...</span>
//                 </div>
//                 <p className="mt-2">Loading records...</p>
//               </div>
//             ) : ledger.length === 0 ? (
//               <div className="text-center py-3">
//                 <p className="text-muted mb-0">No records found.</p>
//               </div>
//             ) : (
//               <>
//                 <div className="table-responsive">
//                   <Table striped bordered hover className="align-middle">
//                     <thead className="table-dark">
//                       <tr>
//                         <th>#</th>
//                         <th>Date</th>
//                         <th>Category Name</th>
//                         <th>Category Type</th>
//                         <th>Payee Name</th>

//                         <th>Type</th>
//                         <th>Project Name</th>
//                         <th>Unit Number</th>
//                         <th>Descriptions</th>
//                         <th>Narration</th>
//                         <th>CR (₹)</th>
//                         <th>DR (₹)</th>
//                         <th>Balance (₹)</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {ledger.map((item, index) => {
//                         const crAmount = parseFloat(item.cr) || 0;
//                         const drAmount = parseFloat(item.dr) || 0;
//                         const transactionAmount =
//                           crAmount > 0 ? crAmount : drAmount;

//                         return (
//                           <tr key={item.id || index}>
//                             <td className="fw-bold">
//                               {(currentPage - 1) * pageLimit + index + 1}
//                             </td>
//                             <td>{formatDate(item.date)}</td>
//                             <td>{item.category.name || "NA"}</td>
//                             <td
//                               style={{
//                                 color:
//                                   item.category.type?.toLowerCase() === "cr"
//                                     ? "green"
//                                     : item.category.type?.toLowerCase() === "dr"
//                                       ? "red"
//                                       : "black",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               {item.category.type
//                                 ? item.category.type.charAt(0).toUpperCase() +
//                                   item.category.type.slice(1).toLowerCase()
//                                 : ""}
//                             </td>

//                             <td>{item.payee || "NA"}</td>

//                             <td>{item.payment_type || "NA"}</td>

//                             <td>{item?.project?.name || "NA"}</td>
//                             <td>{item?.plot?.name || "NA"}</td>

//                             <td>
//                               <div className="table-cell-remark">
//                                 {item.description || "NA"}
//                               </div>
//                             </td>

//                             <td>
//                               <div className="table-cell-remark">
//                                 {item.narration || "NA"}
//                               </div>
//                             </td>
//                             <td>{(item.cr ?? 0).toFixed(2)}</td>

//                             <td>{(item.dr ?? 0).toFixed(2)}</td>

//                             <td>
//                               {item.balance != null
//                                 ? Number(item.balance).toFixed(2)
//                                 : "NA"}
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </Table>
//                 </div>

//                 {/* Enhanced Pagination */}
//                 {totalPages > 1 && (
//                   <>
//                     <div className="d-flex justify-content-between align-items-center mt-3">
//                       <div className="text-muted">
//                         Showing {(currentPage - 1) * pageLimit + 1} to{" "}
//                         {Math.min(currentPage * pageLimit, totalRecords)} of{" "}
//                         {totalRecords} entries
//                       </div>

//                       <div className="d-flex justify-content-end">
//                         <Pagination>
//                           <Pagination.First
//                             onClick={() => handlePageChange(1)}
//                             disabled={currentPage === 1}
//                           />
//                           <Pagination.Prev
//                             onClick={() => handlePageChange(currentPage - 1)}
//                             disabled={currentPage === 1}
//                           />

//                           {getPaginationGroup().map((pageNumber, index) =>
//                             pageNumber === "..." ? (
//                               <Pagination.Ellipsis
//                                 key={`ellipsis-${index}`}
//                                 disabled
//                               />
//                             ) : (
//                               <Pagination.Item
//                                 key={pageNumber}
//                                 active={pageNumber === currentPage}
//                                 onClick={() => handlePageChange(pageNumber)}
//                               >
//                                 {pageNumber}
//                               </Pagination.Item>
//                             ),
//                           )}

//                           <Pagination.Next
//                             onClick={() => handlePageChange(currentPage + 1)}
//                             disabled={currentPage === totalPages}
//                           />
//                           <Pagination.Last
//                             onClick={() => handlePageChange(totalPages)}
//                             disabled={currentPage === totalPages}
//                           />
//                         </Pagination>
//                       </div>
//                     </div>

//                     <div className="text-end mt-2">
//                       <small className="text-muted">
//                         Page {currentPage} of {totalPages}
//                         {totalRecords > 0 &&
//                           ` | Showing ${(currentPage - 1) * pageLimit + 1} to ${Math.min(currentPage * pageLimit, totalRecords)} of ${totalRecords} records`}
//                       </small>
//                     </div>
//                   </>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AdminWalletLedger;
import React, { useEffect, useState, useRef } from "react";
import { Table, Pagination, Row, Col } from "react-bootstrap";
import { BsFiletypeXls } from "react-icons/bs";
import { FaCalendar, FaTimes, FaSearch } from "react-icons/fa";
import { MdFilterAltOff, MdFilterAlt } from "react-icons/md";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const API_URL = process.env.REACT_APP_API_URL;

// ─── Shared input style ───
const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
  transition: "all 0.2s ease",
  background: "#ffffff",
};

function AdminWalletLedger() {
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState({ amount: "", type: "" });
  const [totals, setTotals] = useState({ total_credit: 0, total_debit: 0 });
  const [summary, setSummary] = useState({
    total_cr: 0,
    total_dr: 0,
    opening_balance: 0,
    closing_balance: 0,
    current_balance: 0,
  });
  const token = localStorage.getItem("token");
  const [filterFromDate, setFilterFromDate] = useState(null);
  const [filterToDate, setFilterToDate] = useState(null);
  const [filterToType, setFilterToType] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const datePickerRefFrom = useRef(null);
  const datePickerRefTo = useRef(null);

  const pageLimit = 10;

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const showCustomMessageModal = (title, text) => {
    Swal.fire(title, text, "error");
  };

  // ═══════════════════════════════════════════
  // 🔹 DATE HELPERS
  // ═══════════════════════════════════════════
  const formatDateForServer = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "-";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return "-";
    }
  };

  const formatAmount = (amount) => {
    if (amount === undefined || amount === null) return "0.00";
    const num = parseFloat(amount);
    if (isNaN(num)) return "0.00";
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH LEDGER
  // ═══════════════════════════════════════════
  const fetchLedger = async (page = 1) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();

      if (searchTerm.type || filterToType) {
        params.append("type", searchTerm.type || filterToType);
      }
      if (filterFromDate) {
        params.append("start_date", formatDateForServer(filterFromDate));
      }
      if (filterToDate) {
        params.append("end_date", formatDateForServer(filterToDate));
      }

      params.append("page", page);
      params.append("limit", pageLimit);

      const url = `${API_URL}/get-admin-wallet-ledgers-with-summary?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success === "1" || result.success) {
        setLedger(result.data?.ledger || []);

        if (result.data?.summary) {
          setSummary(result.data.summary);
          setTotals({
            total_credit: result.data.summary.total_cr || 0,
            total_debit: result.data.summary.total_dr || 0,
          });
        }

        if (result.data?.pagination) {
          const paginationData = result.data.pagination;
          setTotalRecords(paginationData.total_records || 0);
          const totalPagesCount = Math.ceil(
            (paginationData.total_records || 0) / pageLimit
          );
          setTotalPages(totalPagesCount || 1);
        }

        setCurrentPage(page);
      } else {
        showCustomMessageModal(
          "Error",
          result.message || "Failed to fetch records."
        );
      }
    } catch (error) {
      console.error("Fetch error:", error);
      showCustomMessageModal(
        "Error",
        "Failed to fetch ledger data. Please check console for details."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchLedger(1);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      fetchLedger(pageNumber);
    }
  };

  // ─── Pagination numbers ───
  const getPaginationGroup = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 3) {
      return [1, 2, 3, 4, "...", totalPages];
    }
    if (currentPage >= totalPages - 2) {
      return [
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }
    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    ];
  };

  // ═══════════════════════════════════════════
  // 🔹 DOWNLOAD EXCEL
  // ═══════════════════════════════════════════
  const handleDownloadFilteredExcel = async () => {
    const token = localStorage.getItem("token");

    try {
      Swal.fire({
        title: "Please wait...",
        text: "Generating your filtered Excel file",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const params = new URLSearchParams({
        amount: searchTerm.amount,
        type: searchTerm.type || filterToType,
        start_date: formatDateForServer(filterFromDate),
        end_date: formatDateForServer(filterToDate),
      }).toString();

      const response = await fetch(
        `${API_URL}/download-admin-wallet-ledger-excel?${params.toString()}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to download Excel");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Filtered Admin Wallet Ledger Report.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.fire({
        icon: "success",
        title: "Download Successful!",
        text: "Filtered Excel report has been downloaded successfully.",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Filtered Excel download failed:", error);
      Swal.fire({
        icon: "warning",
        title: "Download Failed!",
        text: "Please Check Entered From Date & To Date For Downloading Admin Wallet Ledger Report.",
      });
    }
  };

  // ─── Clear filters ───
  const handleClearFilters = () => {
    setFilterFromDate(null);
    setFilterToDate(null);
    setFilterToType("");
    setSearchTerm({ amount: "", type: "" });
    setCurrentPage(1);
    fetchLedger(1);
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
          {/* ═══════ HEADER CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              padding: "24px 30px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                background:
                  "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "26px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📒
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Admin Wallet Ledger Report
              </h1>
              <p
                style={{
                  margin: "3px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                View and export all admin wallet transactions ({totalRecords}{" "}
                total)
              </p>
            </div>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {/* Download Button */}
              <button
                onClick={handleDownloadFilteredExcel}
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #059669, #10b981)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
                  transition: "all 0.2s ease",
                }}
              >
                <BsFiletypeXls size={16} /> Download
              </button>

              {/* Filter Toggle */}
              <button
                onClick={handleToggle}
                title={isFilterActive ? "Hide Filters" : "Show Filters"}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: "1.5px solid #e2e8f0",
                  background: isFilterActive ? "#1e5799" : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e3a5f",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  boxShadow: isFilterActive
                    ? "0 6px 18px rgba(30, 87, 153, 0.3)"
                    : "none",
                }}
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* ═══════ SUMMARY CARDS ═══════ */}
          <Row className="g-3 mb-3">
            <Col md={4}>
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #f0fdf4, #dcfce7)",
                  borderRadius: "16px",
                  padding: "20px",
                  border: "1.5px solid #86efac",
                  boxShadow: "0 8px 24px rgba(5, 150, 105, 0.1)",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "#059669",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "8px",
                  }}
                >
                  Total Credit
                </div>
                <div
                  style={{
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#059669",
                  }}
                >
                  ₹ {formatAmount(summary.total_cr)}
                </div>
              </div>
            </Col>

            <Col md={4}>
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #feeaeb, #fecaca)",
                  borderRadius: "16px",
                  padding: "20px",
                  border: "1.5px solid #fca5a5",
                  boxShadow: "0 8px 24px rgba(220, 38, 38, 0.1)",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "#dc2626",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "8px",
                  }}
                >
                  Total Debit
                </div>
                <div
                  style={{
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#dc2626",
                  }}
                >
                  ₹ {formatAmount(summary.total_dr)}
                </div>
              </div>
            </Col>

            <Col md={4}>
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #fffbeb, #fef3c7)",
                  borderRadius: "16px",
                  padding: "20px",
                  border: "1.5px solid #fcd34d",
                  boxShadow: "0 8px 24px rgba(217, 119, 6, 0.1)",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "#d97706",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "8px",
                  }}
                >
                  Current Balance
                </div>
                <div
                  style={{
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#d97706",
                  }}
                >
                  ₹ {formatAmount(summary.current_balance)}
                </div>
              </div>
            </Col>
          </Row>

          {/* ═══════ MAIN CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px 30px" }}>
              {/* ═══════ FILTER PANEL ═══════ */}
              {isFilterActive && (
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #f8fafc, #f0f6ff)",
                    border: "1.5px dashed #cbd5e1",
                    borderRadius: "14px",
                    padding: "20px",
                    marginBottom: "24px",
                  }}
                >
                  <Row className="g-3">
                    <Col md={4}>
                      <label
                        style={{
                          display: "block",
                          fontSize: "12px",
                          fontWeight: "700",
                          color: "#1e3a5f",
                          marginBottom: "6px",
                        }}
                      >
                        From Date
                      </label>
                      <div style={{ position: "relative" }}>
                        <DatePicker
                          ref={datePickerRefFrom}
                          selected={filterFromDate}
                          onChange={(date) => setFilterFromDate(date)}
                          placeholderText="DD-MM-YYYY"
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showPopperArrow={false}
                          wrapperClassName="w-100"
                          customInput={
                            <input
                              style={{ ...inputStyle, paddingRight: "40px" }}
                            />
                          }
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "14px",
                            transform: "translateY(-50%)",
                            color: "#1e5799",
                            cursor: "pointer",
                          }}
                        >
                          {!filterFromDate ? (
                            <FaCalendar
                              onClick={() =>
                                datePickerRefFrom.current.setOpen(true)
                              }
                            />
                          ) : (
                            <FaTimes
                              onClick={() => setFilterFromDate(null)}
                            />
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col md={4}>
                      <label
                        style={{
                          display: "block",
                          fontSize: "12px",
                          fontWeight: "700",
                          color: "#1e3a5f",
                          marginBottom: "6px",
                        }}
                      >
                        To Date
                      </label>
                      <div style={{ position: "relative" }}>
                        <DatePicker
                          ref={datePickerRefTo}
                          selected={filterToDate}
                          onChange={(date) => setFilterToDate(date)}
                          placeholderText="DD-MM-YYYY"
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showPopperArrow={false}
                          wrapperClassName="w-100"
                          customInput={
                            <input
                              style={{ ...inputStyle, paddingRight: "40px" }}
                            />
                          }
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "14px",
                            transform: "translateY(-50%)",
                            color: "#1e5799",
                            cursor: "pointer",
                          }}
                        >
                          {!filterToDate ? (
                            <FaCalendar
                              onClick={() =>
                                datePickerRefTo.current.setOpen(true)
                              }
                            />
                          ) : (
                            <FaTimes
                              onClick={() => setFilterToDate(null)}
                            />
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col md={4}>
                      <label
                        style={{
                          display: "block",
                          fontSize: "12px",
                          fontWeight: "700",
                          color: "#1e3a5f",
                          marginBottom: "6px",
                        }}
                      >
                        Type
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <select
                          value={filterToType}
                          onChange={(e) => setFilterToType(e.target.value)}
                          style={inputStyle}
                        >
                          <option value="">All Types</option>
                          <option value="cr">Credit (CR)</option>
                          <option value="dr">Debit (DR)</option>
                        </select>
                        <button
                          onClick={() => fetchLedger(1)}
                          style={{
                            padding: "10px 18px",
                            borderRadius: "10px",
                            border: "none",
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                            color: "#ffffff",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            boxShadow:
                              "0 4px 12px rgba(30, 87, 153, 0.3)",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <FaSearch size={12} /> Filter
                        </button>
                        <button
                          onClick={handleClearFilters}
                          style={{
                            padding: "10px 18px",
                            borderRadius: "10px",
                            border: "1.5px solid #e2e8f0",
                            background: "#ffffff",
                            color: "#64748b",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Clear
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

              {/* ═══════ TABLE ═══════ */}
              {loading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "70px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      border: "3px solid #cbd5e1",
                      borderTop: "3px solid #2b6cb0",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "18px",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Loading records...
                  </p>
                </div>
              ) : ledger.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "60px 20px",
                    color: "#94a3b8",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  📭 No records found.
                </div>
              ) : (
                <>
                  <div
                    style={{
                      overflowX: "auto",
                      overflowY: "visible",
                      borderRadius: "14px",
                      border: "1.5px solid #e2e8f0",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        minWidth: "1500px",
                        borderCollapse: "collapse",
                        fontSize: "12.5px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          }}
                        >
                          {[
                            "S.N",
                            "Date",
                            "Category",
                            "Cat. Type",
                            "Payee",
                            "Type",
                            "Project",
                            "Unit",
                            "Description",
                            "Narration",
                            "CR (₹)",
                            "DR (₹)",
                            "Balance (₹)",
                          ].map((th, i) => (
                            <th
                              key={i}
                              style={{
                                padding: "14px 12px",
                                color: "#ffffff",
                                fontWeight: "700",
                                fontSize: "10.5px",
                                textAlign: "left",
                                letterSpacing: "0.4px",
                                textTransform: "uppercase",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {th}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {ledger.map((item, index) => (
                          <tr
                            key={item.id || index}
                            style={{ borderBottom: "1px solid #f1f5f9" }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = "#f8fafc")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = "transparent")
                            }
                          >
                            <td
                              style={{
                                padding: "12px",
                                fontWeight: "700",
                                color: "#1e5799",
                              }}
                            >
                              {(currentPage - 1) * pageLimit + index + 1}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                color: "#64748b",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {formatDate(item.date)}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                fontWeight: "600",
                                color: "#1e3a5f",
                              }}
                            >
                              {item.category?.name || "NA"}
                            </td>
                            <td style={{ padding: "12px" }}>
                              <span
                                style={{
                                  display: "inline-block",
                                  padding: "4px 10px",
                                  borderRadius: "20px",
                                  fontSize: "10.5px",
                                  fontWeight: "700",
                                  background:
                                    item.category?.type?.toLowerCase() ===
                                    "cr"
                                      ? "#e7f9eb"
                                      : item.category?.type?.toLowerCase() ===
                                          "dr"
                                        ? "#feeaeb"
                                        : "#f1f5f9",
                                  color:
                                    item.category?.type?.toLowerCase() ===
                                    "cr"
                                      ? "#059669"
                                      : item.category?.type?.toLowerCase() ===
                                          "dr"
                                        ? "#dc2626"
                                        : "#64748b",
                                  textTransform: "uppercase",
                                }}
                              >
                                {item.category?.type || "NA"}
                              </span>
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                color: "#334155",
                                fontWeight: "500",
                              }}
                            >
                              {item.payee || "NA"}
                            </td>
                            <td style={{ padding: "12px" }}>
                              <span
                                style={{
                                  display: "inline-block",
                                  padding: "4px 10px",
                                  borderRadius: "20px",
                                  fontSize: "10.5px",
                                  fontWeight: "700",
                                  background:
                                    item.payment_type === "online"
                                      ? "#e8f1fb"
                                      : "#fef3c7",
                                  color:
                                    item.payment_type === "online"
                                      ? "#1e5799"
                                      : "#d97706",
                                  textTransform: "capitalize",
                                }}
                              >
                                {item.payment_type || "NA"}
                              </span>
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                color: "#334155",
                              }}
                            >
                              {item?.project?.name || "NA"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                color: "#334155",
                              }}
                            >
                              {item?.plot?.name || "NA"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                color: "#64748b",
                                maxWidth: "180px",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              {item.description || "NA"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                color: "#64748b",
                                maxWidth: "180px",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              {item.narration || "NA"}
                            </td>
                            <td style={{ padding: "12px" }}>
                              {Number(item.cr) > 0 ? (
                                <span
                                  style={{
                                    color: "#059669",
                                    fontWeight: "800",
                                  }}
                                >
                                  ₹ {Number(item.cr).toFixed(2)}
                                </span>
                              ) : (
                                <span style={{ color: "#cbd5e1" }}>—</span>
                              )}
                            </td>
                            <td style={{ padding: "12px" }}>
                              {Number(item.dr) > 0 ? (
                                <span
                                  style={{
                                    color: "#dc2626",
                                    fontWeight: "800",
                                  }}
                                >
                                  ₹ {Number(item.dr).toFixed(2)}
                                </span>
                              ) : (
                                <span style={{ color: "#cbd5e1" }}>—</span>
                              )}
                            </td>
                            <td style={{ padding: "12px" }}>
                              <span
                                style={{
                                  color:
                                    Number(item.balance) >= 0
                                      ? "#059669"
                                      : "#dc2626",
                                  fontWeight: "800",
                                }}
                              >
                                ₹{" "}
                                {item.balance != null
                                  ? Number(item.balance).toFixed(2)
                                  : "0.00"}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* ═══════ PAGINATION ═══════ */}
                  {totalPages > 1 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "20px",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "12.5px",
                          color: "#64748b",
                          fontWeight: "500",
                        }}
                      >
                        Showing {(currentPage - 1) * pageLimit + 1} to{" "}
                        {Math.min(currentPage * pageLimit, totalRecords)} of{" "}
                        {totalRecords} entries
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "6px",
                          flexWrap: "wrap",
                        }}
                      >
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                          style={{
                            padding: "8px 14px",
                            borderRadius: "10px",
                            border: "1.5px solid #e2e8f0",
                            background: "#ffffff",
                            color:
                              currentPage === 1 ? "#cbd5e1" : "#1e5799",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor:
                              currentPage === 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          ‹ Prev
                        </button>

                        {getPaginationGroup().map((p, i) => {
                          if (p === "...") {
                            return (
                              <span
                                key={`ellipsis-${i}`}
                                style={{
                                  padding: "0 6px",
                                  color: "#94a3b8",
                                  fontWeight: "700",
                                }}
                              >
                                ...
                              </span>
                            );
                          }
                          const isActive = p === currentPage;
                          return (
                            <button
                              key={p}
                              onClick={() => handlePageChange(p)}
                              style={{
                                minWidth: "38px",
                                height: "38px",
                                borderRadius: "10px",
                                border: isActive
                                  ? "none"
                                  : "1.5px solid #e2e8f0",
                                background: isActive
                                  ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                  : "#ffffff",
                                color: isActive ? "#ffffff" : "#334155",
                                fontWeight: "700",
                                fontSize: "13px",
                                cursor: "pointer",
                                boxShadow: isActive
                                  ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                                  : "none",
                                transition: "all 0.18s ease",
                              }}
                            >
                              {p}
                            </button>
                          );
                        })}

                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          style={{
                            padding: "8px 14px",
                            borderRadius: "10px",
                            border: "1.5px solid #e2e8f0",
                            background: "#ffffff",
                            color:
                              currentPage === totalPages
                                ? "#cbd5e1"
                                : "#1e5799",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor:
                              currentPage === totalPages
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          Next ›
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default AdminWalletLedger;
